import moment from 'moment';
import Model from '../model';
import { BookingStatuses } from '@/common/api/config';

class BookingItem extends Model {
  constructor(object) {
    super();
    const {
        objectId,
        bookingNo,
        vendorName,
        projectName,
        contactName,
        statusCode,
        statusName,
        appointedAt,
        createdAt,
        serviceName,
        rating,
        tel,
    } = object || {};

    this.objectId = objectId;
    this.bookingNo = bookingNo;
    this.vendorName = vendorName;
    this.projectName = projectName;
    this.contactName = contactName;
    this.statusCode = statusCode;
    this.statusName = statusName;
    this.appointedAt = appointedAt;
    this.createdAt = createdAt;
    this.serviceName = serviceName;
    this.rating = rating;
    this.tel = tel;
  }

  get createdAtDate() {
    return moment.utc(this.createdAt).local().locale('th').format('DD MMM YYYY, HH:mm น.');
    // return moment(this.createdAt).locale('th').format('DD MMM YYYY, HH:mm');
  }

  get appointedAtDate() {
    return moment.utc(this.appointedAt).local().locale('th').format('DD MMM YYYY, HH:mm น.');
    // return moment(this.appointedAt).locale('th').format('DD MMM YYYY, HH:mm');
  }

  get statusColorCode() {
    const colorCode = BookingStatuses.find(v => v.code === this.statusCode).color;
    return colorCode || null;
  }

  get statusBgColorCode() {
    const colorCode = BookingStatuses.find(v => v.code === this.statusCode).bgColor;
    return colorCode || null;
  }
}

export default BookingItem;
